import { FC } from "react";

import { PageLimitProps, filterOutPagesInOtherSections, usePageLimits } from "./helper";
import { PagesCard } from "./topic/activity/detail/PagesCard";

import { CoreUserRoleType } from "components/server-types";
import { t } from "i18n/i18n";
import { Card } from "mds/components/Card";
import { activitySelectors, selectAllRecentlyAssessedPages } from "store/selectors";
import { useListSelector } from "store/store-hooks";

type RecentlyAssessedPagesListProps = PageLimitProps & {
  shouldLinkSidebar?: boolean;
  role?: CoreUserRoleType;
};

// Note: If a role is provided we get pages for that role accross multiple sections.  If not we get current section pages
export const RecentlyAssessedPagesList: FC<RecentlyAssessedPagesListProps> = ({
  showAll,
  onCountChanged,
  shouldLinkSidebar,
  role,
}) => {
  const activities = useListSelector(activitySelectors.filterForCurrentSection);
  const hasRole = Boolean(role);

  const recentlyAssessedPagesInTheLastSevenDays = useListSelector((s) =>
    selectAllRecentlyAssessedPages(s, 7, role),
  );

  const displayPages = usePageLimits(
    filterOutPagesInOtherSections(recentlyAssessedPagesInTheLastSevenDays),
    showAll,
    onCountChanged,
    hasRole,
  );

  const header = t(`section.sidebar.planner.recently_assessed`);

  if (!displayPages.length) {
    return (
      <>
        <div className="m-2 text-black-tint-40">{header}</div>
        <Card className="mb-3" small>
          <div className="body-s p-2 font-light text-black-tint-40">
            {t("section.sidebar.planner.no_pages_recently_assessed")}
          </div>
        </Card>
      </>
    );
  }

  return (
    <PagesCard
      activities={activities}
      header={header}
      pages={displayPages}
      shouldLinkSidebar={shouldLinkSidebar}
      showSectionTitle={hasRole}
    />
  );
};
